import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { ToastProvider, useToast } from '@zillow/constellation-10';
import { AppSelectors } from '../../selectors';

import { toastRecipe } from './styles';

export const ToastRenderer = () => {
  const context = useToast();
  const { pathname } = useLocation();
  const isWizardView = useSelector((state) => AppSelectors.makeIsWizardView(state));
  const lastPathRef = useRef(pathname);

  useEffect(() => {
    // When the route changes, clear all toasts
    if (lastPathRef.current !== pathname) {
      context.dismissAll();
      lastPathRef.current = pathname;
    }
  }, [pathname, context]);

  return (
    <ToastProvider.List
      css={{ marginRight: '0' }} // margin is handled by toastRecipe
      renderToast={(toast) => (
        <ToastProvider.Item
          key={toast.id}
          toast={toast}
          css={toastRecipe.raw({ isWizardView: Boolean(isWizardView) })}
        />
      )}
    />
  );
};
